import { useAuth } from "../auth/AuthProvider";

export default function AccessDenied() {
  const { signOutAdmin, user } = useAuth();

  return (
    <main className="auth-state-page">
      <section className="auth-state-panel">
        <p className="eyebrow">Admin only</p>
        <h1>Access Denied</h1>
        <p>
          {user?.email ?? "This account"} is signed in, but does not have Chor admin
          authorization.
        </p>
        <button type="button" className="primary-button" onClick={() => void signOutAdmin()}>
          Sign out
        </button>
      </section>
    </main>
  );
}
